/* eslint-disable jsx-a11y/anchor-is-valid */
import { Modal } from "antd";
import Table, { ColumnsType } from "antd/lib/table";
import moment from "moment";
import { Link } from "react-router-dom";
import Authorization from "../../../../../component/Authorization";
import { Action, ActionType } from "../../../customer/entity/customer.model";
import { User, UserUI } from "../../entity/user.model";
import { userService } from "../../service/user.service";

export interface CustomerTableProps {
  users: User[];
  onReload: () => void;
}

function UserTable(props: CustomerTableProps) {
  const userTableColumns: ColumnsType<UserUI> = [
    {
      title: "Д/д",
      dataIndex: "index",
      key: "index",
    },
    {
      title: "Нэвтрэх нэр",
      dataIndex: "username",
      key: "username",
    },
    {
      title: "Нэр",
      dataIndex: "firstName",
      key: "firstName",
    },
    {
      title: "Овог",
      dataIndex: "lastName",
      key: "lastName",
    },
    {
      title: "Идэвхтэй эсэх",
      dataIndex: "enabled",
      key: "enabled",
      render: (enabled: boolean) => <div>{enabled ? "Тийм" : "Үгүй"}</div>,
    },
    {
      title: "Үүсгэсэн огноо",
      dataIndex: "createdTimestamp",
      key: "createdTimestamp",
      render: (createdTimestamp: number) => (
        <div>
          {moment(new Date(createdTimestamp)).format("YYYY-MM-DD HH:mm")}
        </div>
      ),
    },
    {
      title: "Үйлдлүүд",
      align: "center",
      key: "actions",
      dataIndex: "actions",
      render: (actions: Action[], record: UserUI) => (
        <div className="list-icons">
          <div className="dropdown">
            <a href="#" className="list-icons-item" data-toggle="dropdown">
              <i className="icon-menu9"></i>
            </a>

            <div className="dropdown-menu dropdown-menu-right">
              {actions.map((action: Action) => {
                if (action.type === ActionType.edit) {
                  return (
                    <Link
                      key={`edit-${record.id}`}
                      to={`/users/${record.id}`}
                      className="dropdown-item"
                    >
                      <i className={action.icon}></i>
                      {action.text}
                    </Link>
                  );
                } else if (action.type === ActionType.delete) {
                  return (
                    <Authorization roles={['user-full']}>
                      <a
                        key={`delete-${record.id}`}
                        href="#"
                        className="dropdown-item"
                        onClick={() => {
                          Modal.confirm({
                            title: "Баталгаажуулах",
                            content: `Та ${record.username} хэрэглэгчийг устгахдаа итгэлтэй байна уу?`,
                            okText: "Үргэлжлүүлэх",
                            cancelText: "Хаах",
                            onOk: () => {
                              userService
                                .deleteUser(record.id!)
                                .then((_x) => props.onReload());
                            },
                          });
                        }}
                      >
                        <i className={action.icon}></i>
                        {action.text}
                      </a>
                    </Authorization>
                  );
                } else {
                  return <></>;
                }
              })}
            </div>
          </div>
        </div>
      ),
    },
  ];

  const customerUIs: UserUI[] = props.users.map((user, index) => {
    const actions: Action[] = [
      { icon: "icon-pencil3", text: "Дэлгэрэнгүй", type: ActionType.edit },
      { icon: "icon-bin2", text: "Устгах", type: ActionType.delete },
    ];
    return {
      ...user,
      actions: actions,
      index: index + 1,
      key: index,
    };
  });

  return (
    <Table
      className="table table-responsive"
      columns={userTableColumns}
      dataSource={customerUIs}
    />
  );
}

export default UserTable;
